import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-5 bg-white border border-gray-200 rounded-2xl shadow-sm mb-4 hover:border-gray-300" }
const _hoisted_2 = { class: "flex justify-between items-center w-full font-medium text-left text-gray-900" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "w-3 h-6 rotate-180 shrink-0",
  fill: "none",
  height: "2",
  viewBox: "0 0 12 2",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = {
  key: 1,
  class: "w-3 h-6 shrink-0",
  fill: "none",
  height: "12",
  viewBox: "0 0 12 12",
  width: "12",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "mb-2 flex justify-between items-center" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-600" }
const _hoisted_11 = { class: "text-sm text-gray-700" }
const _hoisted_12 = ["aria-valuenow"]
const _hoisted_13 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[1] || (_cache[1] = [
                _createElementVNode("path", {
                  d: "M0.75 1H11.25",
                  stroke: "#374151",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                }, null, -1)
              ])))
            : (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[2] || (_cache[2] = [
                _createElementVNode("path", {
                  d: "M6 0.75V11.25M0.75 6H11.25",
                  stroke: "#374151",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                }, null, -1)
              ]))),
          _createElementVNode("h2", _hoisted_6, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _createElementVNode("span", _hoisted_7, [
          _renderSlot(_ctx.$slots, "content-count")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, [
            _renderSlot(_ctx.$slots, "progress-label")
          ]),
          _createElementVNode("span", _hoisted_11, [
            _renderSlot(_ctx.$slots, "progress-percent")
          ])
        ]),
        _createElementVNode("div", {
          "aria-valuenow": _ctx.progress,
          "aria-valuemax": "100",
          "aria-valuemin": "0",
          class: "flex w-full h-1 bg-gray-200 rounded-full overflow-hidden",
          role: "progressbar"
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ width: _ctx.progress + '%' }),
            class: "flex flex-col justify-center overflow-hidden bg-primary text-xs text-white text-center whitespace-nowrap transition duration-500"
          }, null, 4)
        ], 8, _hoisted_12)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}